import React from 'react';
import { SEOHead } from '../components/SEOHead';
import logoPath from '../logo.webp';
// using raster logo.webp for branding on this page

export const CompanyAbout: React.FC = () => {
  return (
    <div className="animate-fade-in pb-20">
      <SEOHead title="About Us - Nida Studios" description="Nida Studios - About Us" />

      <div className="max-w-4xl mx-auto text-center mb-12">
      <img src={logoPath} alt="Nida logo" className="mx-auto w-40 h-auto mb-6" />
        <h1 className="text-4xl md:text-5xl font-serif font-black text-brand-900 mb-4 tracking-tight">About Us</h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto font-serif leading-relaxed">
          Nida Studios is a modern media company dedicated to delivering accurate, engaging, and impactful content that informs, educates, and inspires our audience. Through innovative storytelling and digital creativity, we cover news, entertainment, lifestyle, and social issues that matter most. Our mission is to remain a trusted voice, connect communities, and shape meaningful conversations through quality media.
        </p>
      </div>

      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-brand-100 rounded-lg p-8 shadow-sm">
          <h2 className="text-xl font-bold mb-4">Our Commitment</h2>
          <p className="text-sm text-gray-800 leading-relaxed">
            We strive to produce journalism and media that uplift and inform. If you have questions, story ideas, or partnership inquiries, please visit our <a href="/company/contact" className="text-brand-500 hover:underline">Contact page</a> to get in touch.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompanyAbout;
